import React, { useContext } from "react";

import { type SearchResultSwatch } from "~/types/search";

import { FilterContext } from "~/providers/FilterProvider";

import { MultiList } from "@bared/ui";

export type FilterSectionListProps = {
  className?: string;
  handleCategoryClick?: () => void;
  handleChange: (key: string) => void;
  handleViewAllClick?: () => void;
  hideProductCount?: boolean;
  layout?: "heroBanner";
  options: SearchResultSwatch[];
  viewAllActive?: boolean;
};

export const FilterSectionList = ({
  handleCategoryClick,
  handleChange: handleChangeProp,
  handleViewAllClick,
  hideProductCount,
  layout,
  options,
  viewAllActive,
  className,
}: FilterSectionListProps) => {
  const { showMore, setShowMore, handleScroll } = useContext(FilterContext);

  const mappedOptions = options.map(({ key, checked, doc_count }) => ({
    key,
    checked,
    count: doc_count,
  }));

  const handleChange = (key: string) => {
    handleScroll();
    handleChangeProp(key);

    if (handleCategoryClick) handleCategoryClick();
  };

  return (
    <MultiList
      className={className}
      options={mappedOptions}
      maxOptionsToShow={10}
      handleChange={handleChange}
      handleShowMore={() => setShowMore(!showMore)}
      showMore={showMore}
      showProductCount={hideProductCount}
      layout={layout}
      viewAllActive={viewAllActive}
      handleViewAllClick={handleViewAllClick}
    />
  );
};
